<template lang="pug" src="./order-address.pug"> </template>
<style lang="scss" src="./order-address.scss" scoped> </style>

<script>
import request from '@/utils/request';
import { debounce } from 'debounce';
import { mapState } from 'vuex';

export default {
    props: {
        placeholder: {
            type: String,
            default: null
        },
        isDisabled: Boolean,
        isValid: {
            type: [Number, Boolean],
            default: null
        },
        index: {
            type: Number,
            default: null
        }
    },
    data: () => ({
        isChanged: false,
        search: null,
        autocompleteAdresses: [],
        coords: null,
        disabledLoad: false,
        outCity: false,
        additional: false
    }),
    computed: {
        ...mapState({
            isShowHistory: (state) => state.orders.isShowHistory,
            address: (state) => state.orders.activeOrderAddresses && state.orders.activeOrderAddresses[this.index]
        }),
        fullAddress: {
            get() {
                const addresses = this.$store.state.orders.activeOrderAddresses;
                const address = addresses && addresses[this.index];

                return address;
            }
        },
        address: {
            get() {
                return this.fullAddress && this.fullAddress.osmId ? this.fullAddress : {};
            },
            set(data) {
                this.$store.commit('orders/UPDATE_ACTIVE_ORDER_ADDRESS', {
                    index: this.index,
                    data: data || {}
                });

                if (this.additional && data.osmId) {
                    this.additional = false;
                }

                this.$emit('onAddressChange');
            }
        },
        street: {
            get() {
                return this.fullAddress && this.fullAddress.osmId ? null : this.fullAddress.street;
            },
            set(street) {
                this.setAddressProp('street', street);
                this.$emit('onAddressChange');
            }
        },
        house: {
            get() {
                return this.fullAddress && this.fullAddress.osmId ? null : this.fullAddress.houseNumber;
            },
            set(house) {
                this.setAddressProp('houseNumber', house);
                this.$emit('onAddressChange');
            }
        },
        hasData() {
            return !!Object.keys(this.address).length;
        },
        autofocus() {
            return !this.hasData;
        },
        addresses() {
            if (!this.hasData) {
                return this.autocompleteAdresses;
            }

            return this.autocompleteAdresses.concat([this.address]);
        },
        toggleIcon() {
            return this.showAdditional ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
        },
        showAdditional() {
            return this.street || this.house || this.additional;
        }
    },
    watch: {
        search (val) {
            this.searchAdresses(val);
        },
        fullAddress(val) {
            if (!val.osmId && (val.street || val.houseNumber) && !this.additional) {
                this.additional = true;
            }
        }
    },
    methods: {
        searchAdresses: debounce(async function(addressValue) {
            if (addressValue && addressValue.length >= 3) {
                await request({ method: 'get', url: `/orders/complete/addresses`, params: {
                    q: addressValue,
                    outCity: this.outCity,
                    lang: this.$vuetify.lang.current
                }}).then((res) => {
                    this.autocompleteAdresses = res.data;
                });
            }
        }, 500),

        onAddressChange(address) {
            if (!address) return;

            if (this.index === 0) {
                this.focusComment();
            } else {
                this.focusNextStreet();
            }

            const { latitude, longitude } = address;

            this.$store.commit('orders/SET_ADDRESS_COORDS', {
                latitude,
                longitude
            });
        },

        focusNextStreet() {
            const nextStreet = document.querySelectorAll('.input input:not([type="hidden"])')[this.index + 1];

            if (nextStreet) {
                nextStreet.focus();
            }
        },

        focusHouse() {
            const house = document.querySelectorAll('.house input:not([type="hidden"])')[this.index];

            if (house) {
                house.focus();
            }
        },

        focusComment() {
            const comment = document.querySelector('.comment-input input:not([type="hidden"])');

            if (comment) {
                comment.focus();
            }
        },

        houseEnterPressed() {
            if (this.index == 0) {
                this.focusComment();
            } else {
                this.focusNextStreet();
            }
        },

        onKeyup(event) {
            if (event.keyCode === 13) {
                if (this.index === 0) {
                    this.focusComment();
                } else {
                    this.focusNextStreet();
                }
            }

            if (!this.osmId) {
                if(event.keyCode === 46) {
                    this.$emit('onAddressDelete');
                }
            }
        },

        setAddressProp(prop, value) {
            let data = null;

            if (this.fullAddress && this.fullAddress.osmId) {
                data = Object.assign({}, { [prop]: value });
            }

            this.address = data || Object.assign({}, this.fullAddress, {
                [prop]: value
            });
        }
    }
};
</script>
